module.exports = __webpack_public_path__ + "img/link-externo2.19e2b95a.svg";